import { Redirect } from 'expo-router';
import { ROUTES, FEED_ROUTES } from '@/constants/routes';
import { useDefaultFeed } from '@/hooks/useDefaultFeed';
import { Center } from '@/components/gluestack/center';
import { Spinner } from '@/components/gluestack/spinner';

export default function FeedsIndexRedirect() {
  const { defaultFeed, isLoaded } = useDefaultFeed();

  if (!isLoaded) {
    return (
      <Center className="flex-1">
        <Spinner size="large" color="grey" />
      </Center>
    );
  }

  return <Redirect href={FEED_ROUTES[defaultFeed] ?? ROUTES.FEEDS_GLOBAL} />;
}
